var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"header",attrs:{"title":_vm.$t('common.tiaok'),"left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),(_vm.loading)?_c('van-loading',{staticStyle:{"margin-top":"4rem"},attrs:{"type":"spinner"}}):_c('div',{staticClass:"mainContent",domProps:{"innerHTML":_vm._s(_vm.terms.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }